'use strict';

var StrategiesConfig = function StrategiesConfig($stateProvider) {
  $stateProvider.state('app.strategies', {
    url: '/workflow/strategies',
    ifFeatureEnabled: ['REVENUE_OPTIMIZER'],
    params: {
      transitionData: null
    },
    views: {
      '': {
        template: require('../templates/strategies-panel.html'),
        controller: 'StrategiesController'
      },
      'mainToolbar': {
        template: require('../templates/strategies-toolbar.html'),
        controller: 'StrategiesToolbarController'
      }
    }
  });
};
StrategiesConfig.$inject = ['$stateProvider'];
module.exports = StrategiesConfig;